module.exports = __webpack_public_path__ + "static/img/pro_model.8f6ee10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro_model.png
// module id = 5C0t
// module chunks = 0